import React from 'react';

function Suriname(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123994)">
        <mask
          id="mask0_800_123994"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123994)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 16H36V24H0V16Z"
            fill="#4E8B1D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V6H0V0Z"
            fill="#4E8B1D"
          />
          <path
            d="M0 6.5H-1.5V8V16V17.5H0H36H37.5V16V8V6.5H36H0Z"
            fill="#AF0100"
            stroke="white"
            strokeWidth="3"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0027 14.4942L15.1967 16L15.8367 13.0617L13.5 10.8626L16.664 10.7437L18.0027 8L19.3413 10.7437H22.5L20.1687 13.0617L20.8705 16L18.0027 14.4942Z"
            fill="#FECA00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123994">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Suriname;
